import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { Person2EntityActionTypes } from '../State/actions/person2entity.action';
import { getPerson2EntitiesFetched, getPerson2EntityLatestUpdatedAt } from '../State/selectors/person2entity.selectors';
import { BaseEntityReloadResolver2 } from './resolver.helper';
import { ActivatedRouteSnapshot, Resolve, ResolveFn } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { distinctUntilChanged, filter, map, take, tap } from 'rxjs/operators';
import { Person2EntityEntityTypeEnum } from '../entities/person2entity.entity';
import { EntityTypeEnum } from '../graphql-types';

@Injectable({
    providedIn: 'root',
})
export class Person2EntityResolver extends BaseEntityReloadResolver2 {
    constructor(store: Store<State>) {
        super(getPerson2EntitiesFetched, getPerson2EntityLatestUpdatedAt, Person2EntityActionTypes.Load, store);
    }
}

@Injectable({ providedIn: 'root' })
export class Person2EntityByEntityIdCommissionResolver implements Resolve<boolean> {
    constructor(
        private store: Store<State>,
        private person2EntityResolver: Person2EntityResolver,
    ) {}

    resolve(route: ActivatedRouteSnapshot) {
        const id = route.paramMap.get('commissionId')!;
        if (!id) return of(true);
        return this.store.select(getPerson2EntitiesFetched).pipe(
            distinctUntilChanged(),
            switchMap((fetched) => {
                if (!fetched) {
                    this.store.dispatch(Person2EntityActionTypes.Load({ Payload: { entityId: +id, entityType: Person2EntityEntityTypeEnum.Commission as string as EntityTypeEnum  } }));
                } else {
                    this.person2EntityResolver.resolve();
                }
                return of(true);
            }),
            take(1),
        );
    }
}

